import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import UserState from './contexts/UserContext/index.tsx'
import { QueryRouter } from './routers/index.tsx'
import { parse, stringify } from "qs"
import OutsideCallConsumerWrapper from 'react-outside-call'
import globalContext from './contexts/global.ts'
import SidebarState from './contexts/SidebarContext/index.tsx'
import ModalState from './contexts/ModalContext/index.tsx'
import ToastState from './contexts/ToastContext/index.tsx'
import TooltipState from './contexts/TooltipContext/index.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <UserState>
      <ToastState>
        <ModalState>
          <SidebarState>
            <TooltipState>
              <OutsideCallConsumerWrapper config={globalContext}>
                <QueryRouter stringify={stringify} parse={parse} >
                  <App />
                </QueryRouter>
              </OutsideCallConsumerWrapper> 
            </TooltipState>
          </SidebarState>
        </ModalState>
      </ToastState>
    </UserState>
  </StrictMode>,
)
